import { render, staticRenderFns } from "./SubCollapse.vue?vue&type=template&id=c4e5f586&scoped=true"
import script from "./SubCollapse.vue?vue&type=script&lang=js"
export * from "./SubCollapse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e5f586",
  null
  
)

export default component.exports